import Grid from '@precis-digital/kurama/Grid'
import { styled } from '@precis-digital/kurama/utils'

export const StyledProfileItem = styled(Grid)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  button: {
    alignSelf: 'center',
    marginTop: '16px',
    '&:first-of-type': {
      marginRight: theme.spacing(1)
    }
  },
  '>div': {
    '>div': {
      width: '100%'
    }
  }
}))
